export const ASSESSMENT_ID = '2';
export const DEA_SCHEDULE_CODES = ['1', '2', '3', '4', '5', '6'];
export const BLOOD_PRESSURE_VITAL_ID = '3';
// Keep blood pressure at the first array spot so that during med pass the
// blood pressure systolic/diastolic input fields take up 12 grid columns and
// then the rest 6 grid columns
export const ORDERED_VITALS_BY_ID = [
  BLOOD_PRESSURE_VITAL_ID,
  '5',
  '7',
  '6',
  '4',
  '9',
  '1'
];
export const VITAL_ID_TO_UNIT_MAP: Record<string, string> = {
  [BLOOD_PRESSURE_VITAL_ID]: 'mmHg',
  5: '%',
  7: 'BPM',
  6: 'BPM',
  4: 'mg/dl',
  9: '°F',
  1: 'lbs'
};

export enum VitalsNames {
  Weight = 'Weight',
  Height = 'Height',
  BloodPressure = 'Blood Pressure',
  BloodSugar = 'Blood Sugar',
  OxygenSaturation = 'Oxygen Saturation',
  Pulse = 'Pulse',
  Respiration = 'Respiration',
  LungSounds = 'Lung Sounds',
  Temperature = 'Temperature',
  PainLevel = 'Pain Level'
}

export const EMAIL_REGEX = RegExp('(^$|^.+@.+\\..+$)');
export const CRM_EMAIL_TYPES = [
  'Welcome',
  'Invitation',
  'Follow-Up',
  'Onboarding',
  'Confirmation',
  'Thank You',
  'Newsletter',
  'Feedback/Survey',
  'Job Application/Interview',
  'Sales/Promotional',
  'Cancellation/Rescheduling',
  'Other'
];

export const OVERDUE_TASKS_COPY = 'Outstanding';
export const OVERDUE_CRM_TASKS_COPY = 'Overdue';

export const EXACARE_LOGO_URLS = {
  horizontal:
    'https://public-exacare.s3.amazonaws.com/exacare_logo_horizontal.svg',
  heart: 'https://public-exacare.s3.amazonaws.com/exacare_logo_heart.svg',
  text: 'https://public-exacare.s3.amazonaws.com/exacare_logo_text.svg',
  vertical: 'https://public-exacare.s3.amazonaws.com/exacare_logo_vertical.svg'
};

export const INOVALON_LOGO_URL =
  'https://public-exacare.s3.us-east-1.amazonaws.com/1104ea502e9de19ec3e108c1a48def1d63fc7fed.jpg';

export const PACKAGE_SIZE_LIMIT_IN_PAGES = 700;
export const APPROACHING_THRESHOLD_PAGES = 100;

export const PACKAGE_SIZE_LIMIT_IN_BYTES = 80000000;
export const ONE_HUNDRED_MB_IN_BYTES = 100000000;

export const genderOptions = [
  {
    label: 'Male',
    value: 'male'
  },
  {
    label: 'Female',
    value: 'female'
  },
  {
    label: 'Other',
    value: 'other'
  }
];

export const maritalStatusOptions = [
  {
    label: 'Single',
    value: 'single'
  },
  {
    label: 'Married',
    value: 'married'
  },
  {
    label: 'Widowed',
    value: 'widowed'
  },
  {
    label: 'Divorced',
    value: 'divorced'
  },
  {
    label: 'Significant Other',
    value: 'significant_other'
  },
  {
    label: 'Companion',
    value: 'companion'
  }
];

export const gridProps = {
  container: true,
  spacing: 2,
  sx: {
    maxWidth: {
      sm: 525,
      md: 800,
      lg: 1000
    }
  }
} as const;

export enum LanguageOptions {
  english = 'English',
  spanish = 'Spanish',
  chinese = 'Chinese',
  cantonese = 'Cantonese',
  tagalog = 'Tagalog',
  vietnamese = 'Vietnamese',
  arabic = 'Arabic',
  french = 'French',
  korean = 'Korean',
  russian = 'Russian',
  german = 'German',
  haitian = 'Haitian Creole',
  hindi = 'Hindi',
  portuguese = 'Portuguese',
  italian = 'Italian',
  polish = 'Polish',
  yiddish = 'Yiddish',
  japanese = 'Japanese',
  hebrew = 'Hebrew',
  ukranian = 'Ukrainian'
}

export interface GenericSqlRowOption {
  id: string;
  name: string;
}

export const S3_URL_EXPIRATION_MAX_RETRIES = 3;
